import { useEffect } from 'react'
import { WriteWorkflowTaskModel } from '../../../api/clients/workflowTasks/DTOs'
import { SessionService } from '../../../services/session'
import {
	IInteractiveWorkflowTask,
	IInteractiveWorkflowTaskProps,
	InteractiveWorkflowTaskState,
} from './IInteractiveWorkflowTask'

type PostFormPackageSubmitRedirectTask =
	InteractiveWorkflowTaskState<PostFormPackageSubmitRedirectTaskData>

type PostFormPackageSubmitRedirectTaskData = {
	redirectUrl: string
}

export const PostFormPackageSubmitRedirectTaskId =
	'PostFormPackageSubmitRedirect'

/*
 * This interaction is a little bit different as it really isn't a user interaction,
 * more of a form package/workflow interaction. We need to know that the package is done,
 * then we can send the signal to the workflow to get the url to redirect to within
 * the package host. So really, all this does is send a signal and doesn't request
 * info from the user.
 */

const PostFormPackageSubmitRedirectInteraction = (
	props: IInteractiveWorkflowTaskProps<
		WriteWorkflowTaskModel<PostFormPackageSubmitRedirectTask>
	>,
) => {
	const signalTypeId = 'FormPackageRedirected'
	const sessionService = SessionService.getInstance()

	const redirect = async () => {
		props.onConfirm({
			result: 'okay',
			signalTypeId: signalTypeId,
			resources: [
				{
					type: 'FormPackage',
					value: props.task.workflowTaskState.resourceId,
				},
				{
					type: 'WorkflowTask',
					value: {
						id: props.task.id,
						lockPassword: props.task.lockPassword,
						outcome: 'Done',
						results: {},
						userId: sessionService.userId,
					},
				},
			],
		})
	}

	useEffect(() => {
		redirect()
	}, [])

	return <></>
}

export const PostFormPackageSubmitRedirectTaskDefinition: IInteractiveWorkflowTask<
	WriteWorkflowTaskModel<PostFormPackageSubmitRedirectTask>
> = {
	id: PostFormPackageSubmitRedirectTaskId,
	interaction: PostFormPackageSubmitRedirectInteraction,
}
